<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>停服配置</span>
          <el-button v-permisaction="['config:stopServer:add']" type="primary" size="mini" style="margin-left: 16px;" @click="edit(0)">新增</el-button>
          <clear-cache-apply />
        </div>

        <template>
          <el-table
            :data="tableData"
            border
            style="width: 100%"
          >
            <el-table-column
              prop="id"
              label="ID"
              align="center"
            />
            <el-table-column
              prop="stime"
              label="开始时间"
              align="center"
            />

            <el-table-column
              prop="etime"
              label="结束时间"
              align="center"
            />
            <el-table-column
              prop="device"
              label="设备类型"
              align="center"
              :formatter="deviceFormatter"
            />
            <el-table-column
              prop="usertype"
              label="用户类型"
              align="center"
              :formatter="userTypeFormatter"
            />
            <el-table-column
              prop="type"
              label="停服类型"
              align="center"
              :formatter="typeTypeFormatter"
            />
            <el-table-column
              fixed="right"
              label="操作"
              width="100"
            >
              <template slot-scope="scope">
                <el-button v-permisaction="['config:stopServer:edit']" type="text" size="small" @click="edit(scope.row.id)">编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            v-show="total>0"
            background
            :page.sync="queryParams.pageIndex"
            :limit.sync="queryParams.pageSize"
            :total="total"
            @pagination="getTables"
          />
        </template>
      </el-card>

      <el-drawer
        title="配置"
        :visible.sync="drawer"
        size="700px"
        :before-close="handleClose"
      >
        <el-form ref="formData" :rules="rules" :model="formData" label-width="100px">
          <el-form-item label="标题" prop="title" style="width: 400px;">
            <el-input v-model.number="formData.title" placeholder="标题" />
          </el-form-item>
          <el-form-item label="内容" prop="title" style="width: 400px;">
            <el-input v-model.number="formData.content" placeholder="内容" />
          </el-form-item>
          <el-form-item label="开始时间" prop="stime">
            <el-date-picker v-model="formData.stime" style="width: 300px" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" />
          </el-form-item>
          <el-form-item label="结束时间" prop="etime">
            <el-date-picker v-model="formData.etime" style="width: 300px" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" />
          </el-form-item>
          <el-form-item label="设备类型" prop="device">
            <el-select v-model.number="formData.device" placeholder="请选择">
              <el-option
                v-for="item in deviceType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="用户类型" prop="usertype">
            <el-select v-model.number="formData.usertype" placeholder="请选择">
              <el-option
                v-for="item in usertypeType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="停服状态" prop="type">
            <el-select v-model.number="formData.type" placeholder="请选择">
              <el-option
                v-for="item in statusType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="白名单" prop="wlist" rows="5">
            <el-input v-model="formData.wlist" placeholder="多个用','隔开" type="textarea" />
          </el-form-item>
          <el-form-item label="黑名单" prop="blist" rows="5">
            <el-input v-model="formData.blist" placeholder="多个用','隔开" type="textarea" />
          </el-form-item>
          <el-form-item style="width:100%;margin-top:50px;text-align: center">
            <el-button type="primary" @click="onSubmit()">保存</el-button>
          </el-form-item>
        </el-form>
      </el-drawer>

    </template>
  </BasicLayout>
</template>

<script>
import { getRewardType } from '@/api/config/slot'
import { searchUid } from '@/api/user/user_info'
import { getAnnouncementList, updateAnnouncementCfg } from '@/api/config/announcement-cfg'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'

export default {
  name: 'Announcement',
  components: { ClearCacheApply },
  data() {
    return {
      total: 0,
      rewardTypes: [],
      tableData: [],
      loading: false,
      drawer: false,
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      statusType: [{ label: '停服,白名单可以玩', value: 3 }, { label: '停服', value: 2 }, { label: '不停服', value: 1 }],
      deviceType: [{ label: '全部', value: 0 }, { label: '安卓', value: 1 }, { label: 'IOS', value: 2 }],
      usertypeType: [{ label: '全部', value: 0 }, { label: '安卓', value: 1 }, { label: 'fb', value: 1 }],
      formDataBak: {
        title: '',
        content: '',
        stime: '',
        etime: '',
        device: 0,
        usertype: 0,
        type: 0,
        wlist: '',
        blist: '',
        isvalid: 0,
        announce_type: 0
      },
      formData: {
        title: '',
        content: '',
        stime: '',
        etime: '',
        device: 0,
        usertype: 0,
        type: 1,
        wlist: '',
        blist: '',
        isvalid: 0,
        announce_type: 0
      },
      users: [],
      rules: {
        name: [
          { required: true, message: '请输入可领取数量', trigger: 'blur' }
        ],
        stime: [
          { required: true, message: '请选择开始时间', trigger: 'blur' }
        ], etime: [
          { required: true, message: '请选择结束时间', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    handleClose(d) {
      this.drawer = false
    },
    getRewardTypeData() {
      getRewardType().then(res => {
        if (res.code === 200) {
          this.rewardTypes = res.data
        }
      })
    },
    edit(id) {
      this.$router.push({ name: 'AnnouncementEdit', query: { id: id }})
    },
    addReward() {
      this.formData.rwd.props.push({ propsId: '', num: 1 })
    },
    delReward(i) {
      this.formData.rwd.props = this.formData.rwd.props.filter((item, index) => {
        return index !== i
      })
    },
    onSubmit() {
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          const _data = this.formData
          const ipRegex = /^(\d{1,3}\.){3}\d{1,3}$/
          if (_data.type === 1) {
            if (_data.wlist === '') {
              this.msgError('白名单不能为空')
              return
            }

            if (_data.stime > _data.etime) {
              this.msgError('开始时间不能大于结束时间')
              return
            }

            const ipArray = _data.wlist.split(',')
            let check = ''
            // 验证 IP 地址
            ipArray.forEach(ip => {
              if (!ipRegex.test(ip)) {
                check = `白名单 ${ip} 是一个有效的 IP 地址`
                return
              }
            })

            if (check) {
              this.msgError(check)
              return
            }
          }

          if (_data.blist !== '') {
            const ipArray = _data.blist.split(',')
            // 验证 IP 地址
            let check = ''
            ipArray.forEach(ip => {
              if (!ipRegex.test(ip)) {
                check = `黑名单 ${ip} 是一个有效的 IP 地址`
                return
              }
            })

            if (check) {
              this.msgError(check)
              return
            }
          }

          const data = JSON.stringify(this.formData)
          console.log('data', data)
          updateAnnouncementCfg({ data: data }).then(res => {
            if (res.code === 200) {
              this.drawer = false
              this.formData = this.formDataBak
              this.msgSuccess(res.msg)
              this.getTables()
            } else {
              this.msgError(res.msg)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    getTables() {
      this.loading = true
      getAnnouncementList(this.queryParams).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.tableData = res.data.list
          this.total = res.data.count
        } else {
          this.msgError(res.msg)
        }
      })
    },
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true
        searchUid({ id: query }).then(res => {
          this.loading = false
          this.users = res.data
        })
      } else {
        this.users = []
      }
    },
    add() {
      this.drawer = true
    },
    del(index) {
      this.formData = this.formData.filter((item, key) => {
        return index !== key
      })
    },
    userTypeFormatter(row, col) {
      let userTypeText = ''
      for (const i in this.usertypeType) {
        const val = this.usertypeType[i]
        if (val.value === row.usertype) {
          userTypeText = val.label
          break
        }
      }
      return userTypeText
    },
    deviceFormatter(row, col) {
      let deviceTypeText = ''
      for (const i in this.deviceType) {
        const val = this.deviceType[i]
        if (val.value === row.device) {
          deviceTypeText = val.label
          break
        }
      }
      return deviceTypeText
    },
    typeTypeFormatter(row, col) {
      let typeText = ''
      for (const i in this.statusType) {
        const val = this.statusType[i]
        if (val.value === row.type) {
          typeText = val.label
          break
        }
      }
      return typeText
    }
  }
}
</script>

<style scoped>
</style>
